import { useQuery } from '@tanstack/react-query'

import { useApiContext } from '../context/ApiContext'

export function useProjectCategories() {
  const { apiClient } = useApiContext()

  return useQuery(['project-categories'], () => apiClient.getProjectCategories(), { retry: 2 })
}
